import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <>
      <Helmet>
        <meta httpEquiv="refresh" content={`0;url=${to}`} />
        <link rel="canonical" href={to} />
        <meta name="robots" content="noindex, follow" />
        <title>Redirecting…</title>
      </Helmet>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <p>
          Redirecting to <a href={to}>{to}</a>…
        </p>
      </div>
    </>
  );
};
